@if (state$ | async; as state) {
  @if (state.visible) {
    <div class="batch-export-progress" [ngClass]="state.status">
      <div class="batch-export-header">
        <strong>Exportação de homologações</strong>
        @if (!state.running) {
          <button type="button" title="Fechar" (click)="close()">×</button>
        }
      </div>

      <div class="batch-export-body">
        <p>{{ state.message || 'Processando exportação...' }}</p>
        @if (state.current) {
          <small>Atual: {{ state.current }}</small>
        }

        <div class="progress-info">
          <span>{{ state.processed }} / {{ state.total }}</span>
          <span>{{ getProgress(state.processed, state.total) }}%</span>
        </div>

        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="getProgress(state.processed, state.total)"></div>
        </div>
      </div>
    </div>
  }
}
